export default {
  title: 'Creare link de înregistrare',
  steps: {
    select_gateway: 'Selectați gateway',
    copy_link: 'Copiați linkul',
  },
  select_gateway: {
    description: 'Alegeți gateway-ul de plată pentru care doriți să generați un link de înregistrare de lungă durată.',
  },
  link: {
    proxy_url_label: 'URL de înregistrare',
    expires_label: 'Expiră',
    copy_button: 'Copiați URL',
    copied: 'Copiat!',
    description:
      'Partajați acest URL cu comerciantul. Redirecționează către pagina de înregistrare a gateway-ului și rămâne valid până la data de expirare.',
  },
  buttons: {
    next: 'Înainte',
    back: 'Înapoi',
    done: 'Finalizat',
  },
  toasts: {
    create_success: 'Link de înregistrare creat cu succes.',
    create_failed: 'Crearea linkului de înregistrare a eșuat.',
  },
};
